module.exports = __webpack_public_path__ + "static/media/bearmaps.f8139bae.png";